import { render, staticRenderFns } from "./PasswordChangeView.vue?vue&type=template&id=40a9a8ac&scoped=true"
import script from "./PasswordChangeView.vue?vue&type=script&lang=ts"
export * from "./PasswordChangeView.vue?vue&type=script&lang=ts"
import style0 from "./PasswordChangeView.vue?vue&type=style&index=0&id=40a9a8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9a8ac",
  null
  
)

export default component.exports